import React from "react";

const featureData = [
  {
    icon: "fa fa-link",
    title: "Direct Manufacturer Connection",
    text: "Get authentic, high-quality cement at the lowest cost by bypassing unnecessary middlemen.",
  },
  {
    icon: "fa fa-shopping-cart",
    title: "Seamless Ordering & Tracking",
    text: "Use our app or website for a quick, hassle-free ordering and order tracking experience.",
  },
  {
    icon: "fa fa-truck",
    title: "End-to-End Delivery",
    text: "We handle logistics, ensuring on-time delivery straight to your construction site.",
  },
  {
    icon: "fa fa-phone",
    title: "24/7 Customer Support",
    text: "From order placement to post-delivery assistance, we provide reliable customer care whenever needed.",
  },
];

export const Features = () => {
  return (
    <section id="features" className="text-center py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 mx-auto section-titles">
            <h2>Features</h2>
          </div>
        </div>

        <div className="row">
          {featureData.map((d, i) => (
            <div key={`${d.title}-${i}`} className="col-12 col-md-6 col-lg-3 d-flex align-items-stretch">
              <div className="feature-box p-4 border rounded shadow-sm w-100">
                <i className={`${d.icon} mb-3`} style={{ fontSize: "2rem" }}></i>
                <h3 className="h5">{d.title}</h3>
                <p className="mb-0">{d.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
